import * as React from "react";
import { forwardRef } from "react";
const SvgDotLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: 35, viewBox: "850 0 300 200", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 0, x2: 3e3, y1: 100, y2: 100, stroke: "currentColor", strokeWidth: 20, strokeLinecap: "round", strokeDasharray: "1, 45" }));
const ForwardRef = forwardRef(SvgDotLine);
export { ForwardRef as ReactComponent };
